module.exports = __webpack_public_path__ + "static/img/white-badge.6eb7d6c.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/CGdesign/src/assets/img/logo/white-badge.png
// module id = zanU
// module chunks = 1